import { ClosedDayWebEntity } from "./closed-day.web-entity"
import { KeyValueDataWebEntity } from "./Key-value-data.web-entity"
import { OpeningHourWebEntity } from "./opening-hour.web-entity"
import { ProductDetailsWebEntity } from "./product-details.web-entity"
import { SelectedProductWebEntity } from "./selected-product.web-entity"


export interface PrivateLocatioDetailsWebEntity {
    openingHours?: OpeningHourWebEntity[]
    closedDays?: ClosedDayWebEntity[]
    selectedProducts?: SelectedProductWebEntity[]
    products? : ProductDetailsWebEntity[]
    keyValueData? : KeyValueDataWebEntity[]
    
  }
  



  

  


  

  

  